import { NgStyle } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatCard, MatCardHeader, MatCardSubtitle, MatCardTitle } from "@angular/material/card";
import { MatTooltip } from "@angular/material/tooltip";
import { StyleDirective } from "@ngbracket/ngx-layout/extended";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { CommonChartInfoCard } from "@tylertech/tyler-api-types";

@Component({
    selector: "common-chart-info-card",
    templateUrl: "./commonchartInfoCard.tmpl.html",
    styleUrls: ["./commonChartInfoCard.component.scss"],
    imports: [
        LayoutAlignDirective,
        LayoutDirective,
        StyleDirective,
        MatCard,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatTooltip,
        NgStyle,
    ]
})
export class CommonChartInfoCardComponent
{
    @Input()
    commonChartInfoCard: CommonChartInfoCard;

    get cardStyle(): Record<string, string | number>
    {
        const color = this.commonChartInfoCard.Color;
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "background-color": `rgba(${color.R},${color.G},${color.B},${1.0})`
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }
}
